import { Header, MarginPosition, NavTabs } from '@dreryk/react-components';

import { PatientPanelNavParams } from '../common/common.types';
import { PatientActionBar } from '../common/PatientActionBar';
import { patientTranslationKeys, personalDataTranslationKeys } from '../translations';

import { CreatePatientPersonalData } from './CreatePatientPersonalData/CreatePatientPersonalData';

const CreatePatientPanel = (): JSX.Element => {
   return (
      <PatientActionBar>
         <Header testId={'createPatient'} margin={MarginPosition.BOTTOM}>
            {patientTranslationKeys.addPatientTitle}
         </Header>
         <NavTabs<PatientPanelNavParams> testId={'createPatient'}>
            <NavTabs.Tab
               testId={PatientPanelNavParams.PERSONAL_DATA}
               param={PatientPanelNavParams.PERSONAL_DATA}
               label={personalDataTranslationKeys.tabName}
            >
               <CreatePatientPersonalData />
            </NavTabs.Tab>
         </NavTabs>
      </PatientActionBar>
   );
};

export { CreatePatientPanel };
